import { useServices } from "@/hooks/useServices"

// Single switch for the EVP demo variant of the Triage drawer. Read it here rather
// than calling auth.isDemo() per component — drifting copies would leave a tenant
// without the banners instead of just relocating them.
export const useIsEvpDemo = () => useServices().auth.isDemo()
